import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import LoginForm from './LoginForm';
import { Body4, Headline1 } from '../../app/common/typography';
import { useTranslation } from 'react-i18next';
import { Container, FrameSpacerContainer, InfoMessageContainer } from './styled.registerSuccess';
import { MessageAlert } from '../../app/common/icons/MessageAlert';
import { MyLQAWhiteLogo } from '../../app/common/icons/MyLQAWhiteLogo';

const RegisterSuccess = () => {
  const [params] = useSearchParams();
  const { t } = useTranslation();
  const l = useParams();
  const isRedirectedFromParams = params.get('isRegistered');
  const isRedirectedFromRegisterScreen = isRedirectedFromParams && JSON.parse(isRedirectedFromParams);

  const origin = l && l.origin && l.origin;

  const displayMessage = (origin) => {
    switch (origin) {
        case 'delete':
            return 'You have successfully deleted your myLQA Membership profile';
        case 'updated':
            return 'You have successfully updated your password';
        default:
          return isRedirectedFromRegisterScreen
            ? t('COMMON.OUTSIDE.LABELS.WELCOME_TO_MYLQA')
            : t('COMMON.REGISTER.MESSAGES.MEMBERSHIP_SUCCESSFULLY_REGISTERED');
    }
};

  return (
    <Container>
      <FrameSpacerContainer>
        {isRedirectedFromRegisterScreen ? <MyLQAWhiteLogo /> : <MessageAlert />}
        <Headline1 color="white">{displayMessage(origin)}</Headline1>
        <InfoMessageContainer>
          <Body4>
            {origin !== 'register'
              ? t('COMMON.REGISTER.MESSAGES.RE_ENTER_YOUR_CREDENTIALS_TO_RESUME')
              : t('COMMON.REGISTER.MESSAGES.RE_ENTER_YOUR_CREDENTIALS_TO_USE')}
          </Body4>
        </InfoMessageContainer>
        <LoginForm />
      </FrameSpacerContainer>
    </Container>
  );
};

export default RegisterSuccess;
